import axiosInstance from 'api/axiosInstance';
import { getPropertyIDFromHost } from 'containers/pages/analyticsReport/utils/getPropertyIDFromOrigin';

export const getBasicStats = async (
	startDate: Date,
	endDate: Date,
): Promise<any> => {
	// format should be: 2024-01-01, i.e YYYY-MM-DD
	const startDateStr = startDate.toISOString().split('T')[0];
	const endDateStr = endDate.toISOString().split('T')[0];

	let API_URL = `/getBasicStats?propertyID=${getPropertyIDFromHost()}&startDate=${startDateStr}&endDate=${endDateStr}`;
	// let API_URL = `/getBasicStats?startDate=${}&endDate=${}`;

	if (process.env.NODE_ENV === 'production') {
		API_URL = '/analytics-report' + API_URL;
	} else {
		// Make sure the CANReportsNode server is running on port 3000
		API_URL = 'http://localhost:3000' + API_URL;
	}

	try {
		const response = await axiosInstance.get<any>(API_URL);

		return response.data;
	} catch (error) {
		console.error('Error fetching visit stats:', error);
		throw error;
	}
};
